import { PageHead } from '../components/ui';

/**
 * The KPI Wheel — a Wheel of Fortune whose wedges are scorecard items.
 *
 * Brought across from the standalone app in `C:\Development\Personal\Wheel` by
 * request, and hosted in an ISOLATED IFRAME for the same reason the charter
 * is: it is a self-contained page with its own theme, its own global CSS and a
 * top-level script, none of which should land on the rest of the app.
 *
 * SERVED AS STATIC FILES, NOT srcDoc. The wheel lives in `web/public/kpi-wheel`
 * with its script in a separate `wheel.js`, because a srcDoc frame inherits
 * this page's CSP, and the production `scriptSrc` is `'self'` — an inline
 * <script> would be blocked on the deployed app while passing every local
 * check (the CSP only applies in production). A same-origin file is allowed.
 *
 * ITS DATA IS A SNAPSHOT. The 81 items are copied from the seed in migration
 * 098 rather than read from /api/scorecard-items, which is admin-only while
 * this page is leadership-only. An item added or renamed in Settings >
 * Scorecard Items does not reach the wheel until the list in wheel.js is
 * updated.
 *
 * OML LEVELS ARE THE WHEEL'S OWN. coo.ScorecardItem has no level column, so
 * each item carries a suggested level in wheel.js, and anything a person
 * changes is kept in this browser's localStorage (the frame is same-origin)
 * with Export/Import to move it.
 */
export function KpiWheelPage() {
  return (
    <>
      <PageHead
        title="KPI Wheel"
        lede="Spin to pull a measurable from the scorecard library, then talk it through: where it stands this week and who owns it. Filter by business unit or by the OML level a KPI lives in."
      />
      <iframe title="KPI Wheel" src="/kpi-wheel/index.html" className="kpi-wheel-frame" />
    </>
  );
}
